import { StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  cardContentStyle: {
    paddingHorizontal: 15,
    paddingVertical: 15,
  },
  calendarStyle: {
    paddingBottom: 20,
  },
  textStyle: theme => ({
    fontSize: 18.7,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    paddingBottom: 2,
  }),
  selectedDateTextStyle: theme => ({
    fontSize: 18.7,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    marginBottom: 10.9,
    ...Fonts.type.bold,
  }),
  timeSlotsContainerStyle: {
    marginHorizontal: -7,
    marginVertical: 9,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  timeSlotContainerStyle: {
    width: '46%',
    marginHorizontal: '2%',
    marginBottom: 10
  },
  timeSlotStyle: (isSelected, timeSlotActiveColor, theme) => ({
    borderRadius: 6.2,
    borderColor: isSelected ? timeSlotActiveColor || Colors.ocean : theme.colors.borderColorThree,
    fontWeight: isSelected ? 'bold' : 'normal',
    borderWidth: 1,
    fontSize: 14.6,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    paddingVertical: 12,
    paddingHorizontal: 10,
  }),
  timeSlotsContainerLoadingStyle: {
    marginHorizontal: -7,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  timeSlotContainerLoadingStyle: {
    width: '33%',
    paddingLeft: 8,
    paddingVertical: 7,
  },
  timeSlotLoadingStyle: theme => ({
    borderRadius: 6.2,
    borderColor: theme.colors.shimmerBorder,
    borderWidth: 1,
    color: theme.colors.headerTitleColor,
    paddingVertical: 5,
    height: 30,
  }),
  calendarSelectedDateTextStyle: theme => ({
    color: theme.colors.activeTabColor,
  }),
  calendarArrowStyle: direction => ({
    marginRight: direction === 'right' ? -15 : 0,
    marginLeft: direction === 'left' ? -15 : 0,
  }),
  calendarBackgroundStyle: theme => ({
    calendarBackground: theme.colors.cardBackgroundColor,
  }),
  monthTitleStyle: (theme, withFullMonthName) => ({
    monthTextColor: theme.colors.textColorFive,
    textMonthFontFamily: Fonts.type.VFFont,
    textMonthFontWeight: !withFullMonthName ? Fonts.type.bold.fontWeight : null,
    textMonthFontSize: 18.7,
  }),
  disabledDaysNumbersStyles: theme => ({
    color: theme.colors.buttons.disabled,
  }),
  dateText: theme => ({
    fontSize: 14.6,
    color: theme.colors.textColorFive,
    fontFamily: Fonts.type.VFFont,
    padding: 5
  }),
  todayDate: theme => ({
    color: theme.colors.textColorSix,
  }),
  todayDateContainer: {
    borderColor: Colors.ocean,
    borderWidth: 1,
    borderRadius: 20,
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center'
  },
  selectedContainer: {
    borderRadius: 20,
    backgroundColor: Colors.ocean,
    borderWidth: 0,
  },
  selectedDate: {
    ...Fonts.type.bold,
    color: Colors.white
  },
  dateContainer: {
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center'
  },
  noTimeSlots: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.regular,
    textAlign: 'center',
    alignSelf: 'center',
    flex: 1
  }
})
